import { IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from '@material-ui/core';
import {AddCircle, VisibilityOff, Visibility} from '@material-ui/icons';
import React, {useEffect, useRef, useState} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Group from '../../../Domain/Models/Group';
import { groupRepository } from '../../../Domain/Repositories/GroupRepository';
import DecisionModal from "../../UiComponents/DecisionModal";
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import PredefinedRouteContent from "../PredefinedRoutes/PredefinedRouteContent";
import PredefinedRouteModal from "../PredefinedRoutes/PredefinedRouteModal";
import PredefinedRoute from "../../../Domain/Models/PredefinedRoute";
import {cubeRepository} from "../../../Domain/Repositories/CubeRepository";
import PlayerPairContent from "../PlayerPairs/PlayerPairContent";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import {CompletedCubeService} from "../../../Domain/Services/CompletedCubeService";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));


interface GroupContentParams
{
  groupId: string;
}

export default function GroupContent()
{
  const classes = useStyles();
  const history = useHistory();

  const errorCardControllerRef = useRef<ErrorCardController>(null);
  const {groupId} = useParams<GroupContentParams>();

  const [group, setGroup] = useState<Group>();
  const [loading, setLoading] = useState(false);
  const [idVisible, setIdVisible] = useState(false);
  const [predefinedRouteDialogOpen, setPredefinedRouteDialogOpen] = useState(false);
  const [predefinedRouteToEdit, setPredefinedRouteToEdit] = useState<PredefinedRoute>();
  const [decisionDialogOpen, setDecisionDialogOpen] = useState(false);

  const forceReload = () =>
  {
    setLoading(true);
    groupRepository.load()
      .then(() => cubeRepository.load())
      .then(() =>
      {
        const foundGroup = groupRepository.getById(groupId);
        setGroup(foundGroup);

        if (foundGroup === undefined)
        {
          errorCardControllerRef.current?.addErrorMessage("Group not found");
        }
        setLoading(false);
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message);
      });
  }
  
  const openPredefinedRouteModal = (predefinedRoute?: PredefinedRoute) =>
  {
    setPredefinedRouteToEdit(predefinedRoute);
    setPredefinedRouteDialogOpen(true);
  }

  const handleDialogClose = () =>
  {
    setPredefinedRouteDialogOpen(false);
    setDecisionDialogOpen(false);
    setPredefinedRouteToEdit(undefined);
    forceReload();
  };

  const handleAddToDtrs = () =>
  {
    setDecisionDialogOpen(true);
  }
  
  const handleDecisionAccepted = () =>
  {
    handleDialogClose();
    setLoading(true);
    
    TrafficShapingService.addGroup(groupId)
        .then(() => setLoading(false))
        .catch((e: Error) =>
        {
          setLoading(false);
          errorCardControllerRef.current?.addErrorMessage(e.message)
        });
  }

  useEffect(() =>
  {
    forceReload();

  }, []);

  return (
    <>
      {group !== undefined && (
          <>
        <PredefinedRouteModal
          open={predefinedRouteDialogOpen}
          group={group}
          predefinedRoute={predefinedRouteToEdit}
          onClose={handleDialogClose}
        />

        <DecisionModal
            open={decisionDialogOpen}
            message={`Add group to DTRS?`}
            onAccept={handleDecisionAccepted}
            onCancel={handleDialogClose}
        />
        </>
      )}
      
      <Loading isLoading={loading}>
        <ErrorCardController ref={errorCardControllerRef}/>

        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              {group?.playerPairs.map(x => x.name).join(' vs. ')}
            </Typography>
            <IconButton size="small" color="default" onClick={() => setIdVisible(!idVisible)}>
              { idVisible ? <VisibilityOff/> : <Visibility/> }
            </IconButton>
            <IconButton size="small" color="default" onClick={handleAddToDtrs}>
              <AddCircle/>
            </IconButton>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {idVisible && <TableCell>ID</TableCell>}
                  <TableCell>Name</TableCell>
                  <TableCell>Phase</TableCell>
                  <TableCell>Num. Completed Cubes</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                  <TableRow key={group?.id} hover>
                    {idVisible && <TableCell scope="row">{group?.id}</TableCell>}
                    <TableCell>
                      {group?.playerPairs.map(x => x.name).join(' vs. ')}
                    </TableCell>
                    <TableCell>
                      {group?.currentPhase.toString()}
                    </TableCell>
                    <TableCell>
                      {group !== undefined ? CompletedCubeService.getNumberOfCompletedCubes(group) : 0}
                    </TableCell>
                  </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
        
        {group !== undefined && (
          <>
            <PlayerPairContent
              group={group}
              reload={forceReload}
              errorCardControllerRef={errorCardControllerRef}
              />
            
            <PredefinedRouteContent
              group={group}
              showModal={openPredefinedRouteModal}
              forceReload={forceReload}
              errorCardControllerRef={errorCardControllerRef}
            />
          </>
        )}
        
      </Loading>
    </>
  );
}